Auth = require 'db/auth'
_ = require 'underscore'
{ usesEnglish } = require 'lib/util'

activeChannel = ->
  Auth.me().get('channels')?.active

testOrgsForExperiment = (orgsInTest) ->
  _.find(Auth.me().get('idOrganizations'), (orgId) ->
    orgsInTest.indexOf(orgId) != -1
  )

inActivityFeedExperiment = ->
  orgsInTest = [
    '59dc130d8f0b9e2b7c2b7fa1', # monetization blitz team
    '58adea146fcdb5f4e50bebf2', # atlassian team
    '538627f73cbb44d1bfbb58f0', # trello team
    '57fe68fc6dd32844ed21ec93', # anna@myersroberts.com
    '582b688564158f2aad34c7b9', # strubw@unitil.com
    '58344ece216563776f0f5a02', # NBT Bank
    '582a3644e0460d0a82b3d77b', # Unsplash
    '580ce547b3a7a32ac706ff51', # Boss Mom
    '5820b120167834447b075043', # TLcom Capital
    '581a1dbfe919408e4b1163b7', # V1 co.
    '582241faabde5112d3decb52'  # Oak Pointe Church
  ]

  testOrgsForExperiment(orgsInTest)

inDueSoonExperiment = ->
  orgsInTest = []

  testOrgsForExperiment(orgsInTest)

inUpNextExperiment = ->
  orgsInTest = [
    '59dc130d8f0b9e2b7c2b7fa1', # monetization blitz team
    '58adea146fcdb5f4e50bebf2', # atlassian team
    '538627f73cbb44d1bfbb58f0', # trello team
    '5971fa54ba3b05dccb85cb01', # KVNW
    '5972209e8f7e0888f79ed880', # Lundbeck
    '594ad0ff4781c20133e9bf5e', # k.say@icloud.com
    '587576fa353f09964aebbe74', # New Hampshire Pharmacy
    '59ad33df3fb66e764442db80', # Taube Jewish Heritage Tours
    '59e619b1de65846a9688adfb', # Seek Services
    '583cf548ba6e0919a354c25b', # george@stilllife.studio
    '583c653a8fe9264f7c19e45a', # SocialXpresso
    '583df243ad29ee237f3f2188', # jessica.love.duncan@gmail.com
    '583dffcc107f5c30477a8f8d', # Peter Mead iT
    '59abdb62e653568a38746356', # Wellspring, Inc
    '59ad3ce928674b5f5b07aa39', # Frau
    '594aa562f43993c584f4ff55', # AUI Power
    '594a56e14e1dde66ad67c9bd', # Autonic Group
    '58025f49eea59d13ddf8c4c3', # Penta-Plan Business Empowerment GmbH
    '59722c420d55bf9613f0756a', # Institute of Contemporary Art, Miami
    '583a54498443fd8419376703', # Jovon Miller Productions Inc
    '582a1bc7b22a3efd5478d598', # Think Energy
    '58470f00ce319f5877651f33', # Inside Real Estate
    '584af251a0ee8fb2c9c656fd', # Go Rocket Brand
    '514f3af5eab7c26466001d27', # Hammerhead
    '576a72adb4929e1bfc34d247'  # Mondi Group
  ]

  testOrgsForExperiment(orgsInTest)

module.exports =
  allMembers: ->
    return true
  alphaMembers: ->
    activeChannel() == 'alpha'
  englishMembers: ->
    usesEnglish()
  alphaEnglishMembers: ->
    usesEnglish() && activeChannel() == 'alpha'
  betaEnglishMembers: ->
    usesEnglish() && activeChannel() == 'beta'
  activityFeedMembers: ->
    usesEnglish() && inActivityFeedExperiment()
  dueSoonMembers: ->
    usesEnglish() && inDueSoonExperiment()
  upNextMembers: ->
    usesEnglish() && inUpNextExperiment()



// WEBPACK FOOTER //
// ./app/scripts/lib/experiments/audience-definitions.coffee